import axios, { AxiosResponse } from 'axios';

import { Utilities } from '../../../weborder/Utilities';

export const whitelabel = {
  getAppConfig: (): Promise<AxiosResponse> => {
    const isElixir = !!Utilities.extraOption('data-is-elixir-site');
    if (isElixir) {
      return axios.get('/Account/AppConfig');
    }
    return axios.get(`/Account/AppConfig?isEmbed=true`);
  },
};
